'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';

import { NotFound } from '@/components/Error/NotFound';
import { FillScreen } from '@/components/Layout';
import { featureFlags } from '@/lib/env';

/**
 * IdP-initiated SSO のデモ用フルスクリーンレイアウト。
 * DRESS CODE が IdP として外部 SaaS（Google Workspace 等）へ SSO する利用フローを
 * フロントエンドのみで体験できるプロトタイプ画面群を配置する。
 *
 * GOOGLE_WORKSPACE_SSO_DEMO フラグでゲートし、本番には露出させない。
 * IdP 応答画面・遷移先の SaaS 画面はプロダクトのヘッダー（RootHeader）を持たない
 * 独立した全画面として表示するため、ここでは共通ヘッダーを描画しない。
 */
export const Route = createFileRoute('/_idp-sso-mock')({
  component: IdpSsoMockLayout,
});

function IdpSsoMockLayout() {
  if (!featureFlags.check('GOOGLE_WORKSPACE_SSO_DEMO')) {
    return <NotFound />;
  }

  return (
    <FillScreen className="bg-neutral-fill">
      <Outlet />
    </FillScreen>
  );
}
